/*
 * NewsCard Messages
 *
 * This contains all the text for the NewsCard component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  markAsRead: {
    id: 'app.components.NewsCard.markAsRead',
    defaultMessage: 'Mark as read',
  },
  markAsReadFailed: {
    id: 'app.components.NewsCard.markAsReadFailed',
    defaultMessage: 'Error. Failed to mark news entry as read.',
  },
  showReadNews: {
    id: 'app.components.NewsCard.showReadNews',
    defaultMessage: 'Show read news ({numberOfNews})',
  },
  hideReadNews: {
    id: 'app.components.NewsCard.hideReadNews',
    defaultMessage: 'Hide read news',
  },
  news: {
    id: 'app.components.NewsCard.news',
    defaultMessage: 'Unread news',
  },
  updatedOn: {
    id: 'app.components.NewsCard.updatedOn',
    defaultMessage: '(Updated) ',
  },
});
